import moment from 'moment'
import CONSTANTS from '../utils/order.json'
export default {
  computed: {
    $_requiredValidation () {
      return [val => !!val || 'Required']
    },
    $_selectRequiredValidation () {
      return [
        val => val >= 0 || 'Required'
      ]
    },
    $_multiSelectValidation () {
      return [
        val => !!val || 'Required',
        val => (val && val.length > 0) || 'Required'
      ]
    },
    $_numberValidation () {
      return [
        val => (val) ? /^[0-9]+$/.test(val) || 'Not Valid Number' : true,
        val => (val) ? !isNaN(this.$formatter.replaceCommaWithDot(val)) || 'Not Valid Number' : true
      ]
    },
    $_requiredAndMinValidation () { /* min val is 5 */
      return [
        v => !!v || 'Required',
        v => (v > 4) || 'Minimum width is 5%'
      ]
    },
    $_norwegianNumberValidation () {
      return [
        val => (val) ? /^[0-9.,]+$/.test(val) || 'Not Valid Number' : true,
        val => (val) ? !isNaN(this.$formatter.replaceCommaWithDot(val)) || 'Not Valid Number' : true
      ]
    },
    $_norwegianNumberMinusValidation () {
      return [
        val => (val) ? /^-?[0-9.,]+$/.test(val) || 'Not Valid Number' : true,
        val => (val) ? !isNaN(this.$formatter.replaceCommaWithDot(val)) || 'Not Valid Number' : true
      ]
    },
    $_emailValidation () {
      return [
        (v) => v ? /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/.test(v) || 'Invalid Email Address' : true
      ]
    },
    $_phoneValidation () {
      return [
        (v) => v ? /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(v) || 'Invalid Phone Number' : true
      ]
    },
    $_discountValidation () {
      return [
        (val) => val ? (this.$formatter.replaceCommaWithDot(val) <= 100 && this.$formatter.replaceCommaWithDot(val) >= 0) || 'Invalid Number' : true
      ]
    },
    $_deviationSeverity () {
      return [
        { text: this.$t('message.severity.low'), value: 'low' },
        { text: this.$t('message.severity.medium'), value: 'medium' },
        { text: this.$t('message.severity.high'), value: 'high' }
      ]
    },
    $_productionOrderStatus () {
      return [
        { val: 'draft', text: this.$t('message.common.draft') },
        { val: 'inprogress', text: this.$t('message.common.inProgress') },
        { val: 'received', text: this.$t('message.common.completed') }
      ]
    },
    $_PERMISSIONS_LIST () {
      return [{
        text: 'message.permissions.manageShifts',
        id: 100
      }, {
        text: 'message.permissions.manageOpencartOrders',
        id: 101
      }, {
        text: 'message.permissions.manageShopboxOrders',
        id: 102
      }, {
        text: 'message.permissions.manageSettings',
        id: 103
      }]
    },
    listOfUserRoles () {
      return [
        { name: this.$t('message.userRole.administrator'), id: 1 },
        { name: this.$t('message.userRole.office'), id: 2 },
        { name: this.$t('message.userRole.technician'), id: 3 }
      ]
    },
    $_languagesList () {
      return [
        { title: this.$t('message.common.norwegian'), value: 'no' },
        { title: this.$t('message.common.english'), value: 'en' }
      ]
    },
    $_locations () {
      return [
        { text: this.$t('message.customer.norwegianLoc'), value: 'norwegian' },
        { text: this.$t('message.customer.foreign'), value: 'foreign' }
      ]
    },
    $_listOfAddressTypes () {
      return [
        { title: this.$t('message.customer.visit'), value: 'visit' },
        { title: this.$t('message.customer.delivery'), value: 'delivery' },
        { title: this.$t('message.customer.invoice'), value: 'invoice' }
      ]
    },
    $_listOfCustomerStates () {
      return [
        { name: this.$t('message.customer.buyingCustomer'), id: 1 },
        { name: this.$t('message.customer.potentialCustomer'), id: 2 }
      ]
    },
    $_orderStatus () {
      return [{
        text: this.$t('message.common.draft'),
        value: 'draft'
      }, {
        text: this.$t('message.common.inProgress'),
        value: 'inprogress'
      }, {
        text: this.$t('message.common.ordered'),
        value: 'ordered'
      }, {
        text: this.$t('message.common.received'),
        value: 'received'
      }, {
        text: this.$t('message.common.partiallyReceived'),
        value: 'partiallyreceived'
      }, {
        text: this.$t('message.common.request'),
        value: 'request'
      }, {
        text: this.$t('message.common.partiallyPicked'),
        value: 'partiallypicked'
      }, {
        text: this.$t('message.common.picked'),
        value: 'picked'
      }]
    },
    $_priorityList () {
      return [{
        text: this.$t('message.common.low'), value: 'low'
      }, {
        text: this.$t('message.common.medium'), value: 'medium'
      }, {
        text: this.$t('message.common.high'), value: 'high'
      }]
    },
    $_ccsheetStatus () {
      return [{
        text: 'message.ccsheet.ongoing',
        value: 'ongoing'
      }, {
        text: 'message.ccsheet.counted',
        value: 'counted'
      }, {
        text: 'message.ccsheet.recount',
        value: 'recount'
      }, {
        text: 'message.ccsheet.completed',
        value: 'completed'
      }, {
        text: 'message.ccsheet.completedAndAdjusted',
        value: 'completed_and_adjusted'
      }]
    },
    $_orderType () {
      return [{ text: this.$t('message.whOrder.supplierOrder'), value: 'supplier' },
        { text: this.$t('message.whOrder.adjustmentOrder'), value: 'adjustment' },
        { text: this.$t('message.whOrder.returnOrder'), value: 'return' },
        { text: this.$t('message.whOrder.transferOrder'), value: 'transfer' }]
    },
    $_salesOrderStatus () {
      return [{
        name: this.$t('message.common.new'), id: CONSTANTS.NEW
      }, {
        name: this.$t('message.orders.stockAvailable'), id: CONSTANTS.STOCK_AVAILABLE
      }, {
        name: this.$t('message.orders.planned'), id: CONSTANTS.PLANNED
      }, {
        name: this.$t('message.orders.toBeShipped'), id: CONSTANTS.TO_BE_SHIPPED
      }, {
        name: this.$t('message.orders.shipped'), id: CONSTANTS.SHIPPED
      }, {
        name: this.$t('message.orders.closed'), id: CONSTANTS.CLOSED
      }, {
        name: this.$t('message.orders.deleted'), id: CONSTANTS.DELETED
      }]
    },
    listChecklistOfStatus () {
      return [{
        id: 'draft',
        name: this.$t('message.common.draft')
      }, {
        id: 'completed',
        name: this.$t('message.common.completed')
      }]
    }
  },
  methods: {
    $_maxCharValidation (count) {
      return [
        val => !!val || 'Required',
        val => (val && val.toString().length && val.toString().length <= count) || this.$t('message.common.maxCharacters', { charCount: count })
      ]
    },
    $_replaceDotWithComma (value) {
      if (value === null || value === undefined || value === '') return ''
      return parseFloat(value).toFixed(2).toString().replace('.', ',')
    },
    $_replaceDotWithCommaWOFixed (value) {
      if (value === null || value === undefined || value === '') return ''
      return value.toString().replace('.', ',')
    },
    $_replaceCommaWithDot (value) {
      if (!value) return ''
      return value.toString().replace(',', '.')
    },
    $_filterDate (date) {
      if (!date) return null
      return moment(date, 'DD.MM.YYYY').isValid() ? moment(date, 'DD.MM.YYYY').format('DD.MM.YYYY') : null
    },
    $_filterDateTime (date) {
      if (!date) return null
      return moment(date, 'DD.MM.YYYY HH:mm:ss').isValid() ? moment(date, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY HH:mm:ss') : null
    },
    $_getRandomNumberInBW (min, max) {
      return parseInt(Math.random() * (max - min) + min)
    },
    $_isArrayHasData (array) {
      if (array && array.length > 0) return true
      else return false
    },
    // _getSumBy([4, 2, 8, 6]) // 20
    $_getSum (arr) {
      return [...arr].reduce((acc, val) => acc + val, 0)
    },
    // _getSumBy([{ n: 4 }, { n: 2 }, { n: 8 }, { n: 6 }], x => x.n) // 20
    $_getSumBy (arr, fn) {
      const self = this
      if (this.$_isArrayHasData(arr)) {
        return arr.map(typeof fn === 'function' ? fn : val => val[fn]).reduce(function (acc, val) {
          return self.$formatter.replaceCommaWithDotCal(acc) + self.$formatter.replaceCommaWithDotCal(val)
        }, null)
      } else return null
    },
    $_getCurrentDate () {
      return moment(new Date()).format('DD.MM.YYYY')
    },
    $_groupBy (array, key) {
      return array.reduce(function (total, item) {
        total[item[key]] = total[item[key]] || []
        total[item[key]].push(item)
        return total
      }, {})
    },
    // _findValueInArray([{ n: 4, b: 10 }, { n: 2, b: 11 }], x => x.b === 10) // { n: 4, b: 10 }
    $_findValueInArray (array, condition) {
      const getObj = array.find(condition)
      if (getObj) return getObj
      else return null
    },
    // _getSingleValueFromObject([{ n: 4, b: 10 }, { n: 2, b: 11 }], x => x.b) // [10, 11]
    $_mapDataInArray (array, condition) {
      const getObj = array.map(condition)
      if (getObj) return getObj
      else return null
    },
    /* {
        number: { list:['qty', 'price'], format: 'replaceCommaWithDot' },
        date: { list:['start', 'end'], from: 'DD.MM.YYYY', to: 'YYYY.MM.DD'},
        status: { list:['status'], text: '', value: '$_ccsheetStatus' },
        merge: { list:['firstname', 'lastname'], property: 'username' }
    */
    $_formatModel (model, data) {
      model = JSON.parse(JSON.stringify(model))
      const keys = Object.keys(data)
      keys.forEach(key => {
        switch (key) {
          case this.NUMBER: {
            const formatObj = data[this.NUMBER]
            formatObj[this.LIST].forEach(item => {
              model[item] = this.$formatter[formatObj[this.FORMAT]](model[item])
            })
            break
          }
          case this.DATE: {
            const formatObj = data[this.DATE]
            formatObj[this.LIST].forEach(item => {
              const dateObj = this.$formatter.formatDate(model[item], formatObj[this.FROM], formatObj[this.TO])
              model[item] = dateObj
            })
            break
          }
          case this.STATUS: {
            const formatObj = data[this.STATUS]
            formatObj.forEach(item => {
              item[this.LIST].forEach(record => {
                const statusArray = this[item[this.VALUE]]
                statusArray.map(function (x) {
                  if (x.value === model[record]) model[record] = { text: x.text, value: model[record] }
                })
              })
            })
            break
          }
          case 'merge': {
            const formatObj = data.merge
            model[formatObj.property] = `${model[formatObj[this.LIST][0]] || ''} ${model[formatObj[this.LIST][1]] || ''}`
            break
          }
          case this.ADJUSTMENTORDER: {
            model.receivedqty = model.qty
            break
          }
          case 'arrayStringJoin': {
            const formatObj = data.arrayStringJoin
            formatObj[this.LIST].forEach(item => {
              if (model[item]) model[item] = JSON.parse(model[item]).join(', ')
            })
            break
          }
          default:
            break
        }
      })
      return model
    },
    // Array of $_formatModel FUNCTION
    $_formatListModel (listOfModel, data) {
      if (this.$formatter.isArrayHasData(listOfModel)) {
        const result = []
        listOfModel.forEach(model => {
          result.push(this.$_formatModel(model, data))
        })
        return result
      } else return []
    },
    $_sortByType (item1, item2) {
      if (typeof (item1) === 'string' && typeof (item2) === 'string') {
        if (/^\d+$/.test(item2) && /^\d+$/.test(item1)) {
          return item1.localeCompare(item2, undefined, {
            numeric: true
          })
        }
        return item1.localeCompare(item2)
      } else {
        return item1 < item2 ? -1 : 1
      }
    },
    $_customSorting (items, index, isDesc, dateColumnArray, type) {
      items.sort((a, b) => {
        if (dateColumnArray.includes(index)) {
          const date1 = a[index]
          const date2 = b[index]
          if (!isDesc) {
            return this.$_sortWithDates(date1, date2, type)
          } else {
            return this.$_sortWithDates(date2, date1, type)
          }
        } else {
          if (!a[index]) a[index] = ''
          if (!b[index]) b[index] = ''
          if (!isDesc) {
            return this.$_sortByType(a[index], b[index])
          } else {
            return this.$_sortByType(b[index], a[index])
          }
        }
      })
      return items
    },
    $_sortWithDates (date1, date2, type) {
      if (date1 === '' || date1 === null) return -1
      if (date2 === '' || date2 === null) return 1
      var dateA = moment(date1, type)
      var dateB = moment(date2, type)
      return dateA - dateB
    },
    // Set Foreground color based on the background color
    $_foreGroundColor (colorValue) {
      const rgbCode = colorValue ? this.$_hexToRgbA(colorValue) : ''
      const color = rgbCode ? rgbCode.toString().split('(')[1] : ''
      const resultOnColor = color.split(',', 3)
      const R = resultOnColor[0]
      const G = resultOnColor[1]
      const B = resultOnColor[2] ? resultOnColor[2].toString().replace(')', '') : 0
      const C = [R / 255, G / 255, B / 255]
      for (var i = 0; i < C.length; ++i) {
        if (C[i] <= 0.03928) {
          C[i] = C[i] / 12.92
        } else {
          C[i] = Math.pow((C[i] + 0.055) / 1.055, 2.4)
        }
      }
      const L = 0.2126 * C[0] + 0.7152 * C[1] + 0.0722 * C[2]
      if (L > 0.179) {
        return 'black'
      } else {
        return 'white'
      }
    },
    $_hexToRgbA (hex) {
      hex = hex.slice(0, -2)
      var c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',1)'
      }
      return null
    },
    $_downloadExportedReport (filename) {
      return new Promise((resolve, reject) => {
        window.open(`${process.env.VUE_APP_URL}/file/download/?fileName=${filename}`, '_blank')
        resolve()
      })
    },
    $_thousandSeparator (num) {
      if (num !== '' && typeof num !== 'undefined') {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
      } else {
        return num
      }
    }
  }
}
